<template>
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 3L11.6 3M16 3V7.125M16 3L10 9" stroke="currentColor" />
    <path
      d="M9.67857 5H5C3.89543 5 3 5.89543 3 7V14C3 15.1046 3.89543 16 5 16H12C13.1046 16 14 15.1046 14 14V9.32143"
      stroke="currentColor"
    />
  </svg>
</template>
